// Image assets - all photos + logo
const B1 = 'https://customer-assets.emergentagent.com/job_luxury-stays-110/artifacts';
const B2 = 'https://customer-assets.emergentagent.com/job_990ce504-4f2c-416d-9ad7-0f2b284130e7/artifacts';

export const ASSETS = {
  // Logo
  logo: `${B2}/s52miw4l_WhatsApp%20Image%202026-06-11%20at%2019.25.37.jpeg`,

  // NEW Hero pool photo
  heroPool: `${B1}/yq7vmso3_WhatsApp%20Image%202026-06-28%20at%2018.47.17.jpeg`,

  // Photo set
  poolNightUmbrellas: `${B1}/6hbdlzm4_WhatsApp%20Image%202026-06-26%20at%2018.42.54%283%29.jpeg`,
  poolDay: `${B1}/gv9vxmlp_WhatsApp%20Image%202026-06-26%20at%2018.42.54%285%29.jpeg`,
  poolAerialDay: `${B1}/zsp088j9_WhatsApp%20Image%202026-06-26%20at%2018.42.54%286%29.jpeg`,
  artWoman: `${B1}/zjg2qtoi_WhatsApp%20Image%202026-06-26%20at%2018.42.54%287%29.jpeg`,
  artVases: `${B1}/bh1b3hx8_WhatsApp%20Image%202026-06-26%20at%2018.42.54%288%29.jpeg`,
  artDecor: `${B1}/lu6fxi0n_WhatsApp%20Image%202026-06-26%20at%2018.42.54%2813%29.jpeg`,
  poolNight: `${B1}/7x2pg9wr_WhatsApp%20Image%202026-06-26%20at%2018.42.54%289%29.jpeg`,
  gardenLifeOld: `${B1}/oimh12sm_WhatsApp%20Image%202026-06-26%20at%2018.42.54%2810%29.jpeg`,
  bedroom: `${B1}/rzdpjhyt_WhatsApp%20Image%202026-06-26%20at%2018.42.54%2810%29.jpeg`,
  poolside: `${B1}/poyzmijn_WhatsApp%20Image%202026-06-26%20at%2018.42.54%2811%29.jpeg`,
  gardenLife: `${B1}/mxikqwvz_WhatsApp%20Image%202026-06-26%20at%2018.42.54%2812%29.jpeg`,
  extraShot: `${B1}/kuptlcsk_WhatsApp%20Image%202026-06-26%20at%2018.42.54%282%29.jpeg`,
  poolAerial: `${B2}/wfi869zh_WhatsApp%20Image%202026-06-26%20at%2018.42.54%2814%29.jpeg`,
  living: `${B2}/6lvkuemr_WhatsApp%20Image%202026-06-26%20at%2018.42.54%2815%29.jpeg`,
  kitchen: `${B2}/oh1hakwq_WhatsApp%20Image%202026-06-26%20at%2018.42.54%2816%29.jpeg`,
  bathroom: `${B2}/qdrygesj_WhatsApp%20Image%202026-06-26%20at%2018.42.54%2817%29.jpeg`
};

ASSETS.pool = ASSETS.poolDay;

// All photos for gallery
export const GALLERY = [
  ASSETS.heroPool,
  ASSETS.living,
  ASSETS.bedroom,
  ASSETS.kitchen,
  ASSETS.poolside,
  ASSETS.bathroom,
  ASSETS.gardenLife,
  ASSETS.poolAerialDay,
  ASSETS.poolNightUmbrellas,
  ASSETS.gardenLifeOld,
  ASSETS.poolAerial,
  ASSETS.poolNight,
  ASSETS.artDecor,
  ASSETS.extraShot
];

// Real Zakynthos place photos
export const ZAKYNTHOS_PLACES = {
  navagio: 'https://images.unsplash.com/photo-1571021785662-712e369a2829?w=1200&q=85&auto=format&fit=crop',
  blueCaves: 'https://images.unsplash.com/photo-1548678967-f1aec58f6fb2?w=1200&q=85&auto=format&fit=crop',
  marathonisi: 'https://images.pexels.com/photos/37613587/pexels-photo-37613587.jpeg?auto=compress&cs=tinysrgb&w=1200',
  tsilivi: 'https://images.pexels.com/photos/1174732/pexels-photo-1174732.jpeg?auto=compress&cs=tinysrgb&w=1200',
  zanteTown: 'https://images.pexels.com/photos/2549018/pexels-photo-2549018.jpeg?auto=compress&cs=tinysrgb&w=1200',
  cuisine: 'https://images.pexels.com/photos/1640775/pexels-photo-1640775.jpeg?auto=compress&cs=tinysrgb&w=1200'
};

export const CONFIG = {
  whatsapp: '306937502576',
  whatsappDisplay: '+30 693 750 2576',
  email: 'info@moonlit-villa.gr',
  bookingUrl: 'https://www.booking.com/hotel/gr/breeze-villa.el.html?chal_t=1782488831949&force_referer=https%3A%2F%2Fwww.google.com%2F',
  address: 'Planos, Zakynthos, 29100'
};
